<template>
    <div id="app">
        <header>
            <div class="lg:tw-container">
                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                    <div class="header-mobile">
                        <div class="tw-flex tw-justify-center tw-py-5 lg:tw-justify-start lg:tw-pt-12 lg:tw-pb-12">
                            <img src="~@/assets/img/logo.svg">
                        </div>
                        <div>
                            <h1>Aceita ganhar uma vida<br> mais saudável e ainda<br> <span>bónus</span> <b>no prémio do<br> seu seguro de saúde?</b></h1>
                        </div>
                        <div class="header-container tw-px-2 tw-py-3 tw-mt-3 tw-mb-8 lg:tw-mt-5 lg:tw-px-5 lg:tw-mb-0">
                            <p>Cuide de si e ganhe prémios<br>com o <b>Multicare Vitality</b></p>
                        </div>
                    </div>
                    <div class="tw-relative">
                        <Form v-if="!$store.state.formSuccess && !$store.state.formError" />
                        <FormSuccess v-if="$store.state.formSuccess && !$store.state.formError" />
                        <FormError v-if="!$store.state.formSuccess && $store.state.formError" />
                    </div>
                </div>
            </div>
        </header>

        <!-- This will be reaplced by the view defined in the router -->
        <main>
            <div class="tw-container tw-pt-8 lg:tw-pt-16">
                <div class="tw-text-center">
                    <h2>Corra para ganhar prémios<br class="mobile"> com o <span class="multicare-vitality">Multicare Vitality</span></h2>
                    <p class="tw-pt-4 lg:tw-pt-6">O <b>Multicare Vitality</b> é o programa para ter<br class="mobile"> uma vida mais saudável, ganhar prémios,<br class="mobile"> bónus e descontos em<br class="desktop"> parceiros. Associado<br class="mobile"> ao seguro de saúde Multicare, este é um<br class="mobile"> programa baseado num sistema de<br class="mobile"> recompensas<br class="desktop"> por hábitos de vida saudáveis e<br class="mobile"> objetivos de atividade física, que permite<br class="mobile"> conhecer e melhorar a sua saúde.</p>
                    <p class="challenge tw-pt-8 lg:tw-pt-12"> Aceita o Desafio?</p>
                    <div class="tw-text-center tw-mt-4 lg:tw-mt-6 tw-pb-10 lg:tw-pb-20">
                        <button
                            type="button"
                            class="tw-relative btn-cta"
                            @click="scrollTo('form')"
                        >
                            LIGUEM-ME
                        </button>
                    </div>
                </div>
            </div>
        </main>

        <section class="prizes tw-container">
            <div class="tw-grid tw-grid-cols-1 tw-pt-6 tw-pb-12 lg:tw-grid-cols-2 lg:tw-pt-20 lg:tw-gap-20">
                <div class="">
                    <img src="~@/assets/img/prizes.png">
                </div>
                <div class=" lg:tw-pt-12">
                    <p>Associada ao seguro de saúde, só tem de fazer o download da app Multicare Vitality e começar a <b>ganhar prémios</b>.</p>
                    <div class="tw-text-center lg:tw-mt-5 lg:tw-text-left">
                        <button
                            type="button"
                            class="btn-cta tw-relative tw-mt-8 lg:tw-mt-0"
                            @click="scrollTo('form')"
                        >
                            SABER MAIS
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section class="rewards tw-pt-6 tw-pb-5 lg:tw-pt-16 lg:tw-pb-5">
            <div class="tw-container">
                <div>
                    <h2>Quantos mais hábitos de vida saudáveis acumular <br class="desktop">na App Multicare Vitality, <span>mais recompensas terá</span>.</h2>
                </div>
                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 lg:tw-gap-8">
                    <div class="rewards-containers tw-mx-auto tw-px-3 tw-mt-10 lg:tw-px-6 lg:tw-mt-12">
                        <h3 class="tw-pt-5 lg:tw-pt-10">DESCONTOS<br>EM PARCEIROS</h3>
                        <p class="tw-pt-3 lg:tw-pt-4">Acumule FidCoins para utilizar em marcas de comida saudável, material desportivo, entretenimento, produtos de conveniência, retalho e muito mais.</p>
                        <div class="tw-grid tw-grid-cols-2 tw-items-center tw-justify-center tw-pt-3 tw-pb-2 lg:tw-grid-cols-4 lg:tw-gap-1 lg:tw-pt-6 lg:tw-pb-20">
                            <div class="">
                                <img src="~@/assets/img/logo_celeiro.svg">
                            </div>
                            <div class="">
                                <img src="~@/assets/img/logo_decathlon.svg">
                            </div>
                            <div class="">
                                <img src="~@/assets/img/logo_nos.svg">
                            </div>
                            <div class="">
                                <img src="~@/assets/img/logo_pingodoce.svg">
                            </div>
                        </div>
                    </div>
                    <div class="rewards-containers tw-mx-auto tw-px-3 tw-mt-5 lg:tw-px-6 lg:tw-mt-12">
                        <h3 class="tw-pt-5 lg:tw-pt-10">VANTAGENS NA COMPRA<br>DE UM SMARTWATCH</h3>
                        <p class="tw-pt-3 lg:tw-pt-4">Adquira um smartwatch e poderá receber o seu valor até 150€/ano em FidCoins, durante 2 anos.*</p>
                        <img class="tw-pt-4 lg:tw-pt-16" src="~@/assets/img/logo_garmin.svg">
                        <p class="legend tw-pt-3 tw-pb-6">A Apple não é participante ou patrocinadora desta promoção. Apple Watch<br> é uma marca registrada da Apple Inc. Todos os direitos reservados.</p>
                    </div>
                    <div class="rewards-containers tw-mx-auto tw-px-3 tw-mt-5 lg:tw-px-6 lg:tw-mt-12">
                        <h3 class="tw-pt-5 lg:tw-pt-10">BÓNUS NO PRÉMIO<br>DO SEGURO DE SAÚDE </h3>
                        <p class="tw-pt-3 lg:tw-pt-4" style="padding-bottom:118px;">Até 15% de bónus no seguro de saúde. Quanto maior o seu status na app Multicare Vitality, maior será o Bónus, no momento da renovação.</p>
                    </div>
                </div>
                <div class="tw-text-center tw-mt-5 lg:tw-mt-16 ">
                        <button
                            type="button"
                            class="tw-relative btn-cta"
                            @click="scrollTo('form')"
                        >
                            LIGUEM-ME
                        </button>
                </div>
                <div class="tw-pt-6 lg:tw-pt-12">
                    <p class="warning">*O reembolso em FidCoins relativo à aquisição de um smartwatch no âmbito do programa Vitality, só poderá ocorrer novamente 2 anos após a aquisição do anterior device.</p>
                </div>
            </div>
        </section>

        <section class="benefits tw-container tw-pt-8 tw-pb-5 lg:tw-pt-12 lg:tw-pb-24">
            <h2>A Multicare oferece-lhe<br class="lg:tw-hidden"> <b>vantagens diferenciadoras</b></h2>
            <div class="tw-grid tw-grid-cols-1 tw-pt-6 lg:tw-grid-cols-3 lg:tw-pt-10">
                <div class="">
                    <img src="~@/assets/img/icons/medicina.svg">
                    <h3 class="tw-pt-4">Medicina Online</h3>
                    <p class="tw-pt-2">A Multicare disponibiliza aos seus clientes um<br> serviço médico por telefone, email ou<br> vídeo-consulta, 24h/7 dias, assegurado por<br> médicos de Medicina Geral e Familiar, sem<br> qualquer custo adicional. E também um<br> <b>Avaliador de Sintomas Online</b>, para obter um<br> diagnóstico rápido e de forma prática.</p>
                </div>
                <div class="tw-pt-12 lg:tw-pt-0">
                    <img src="~@/assets/img/icons/domicilio.svg">
                    <h3 class="tw-pt-4">Medicamentos ao Domicílio</h3>
                    <p class="tw-pt-2">A pensar em si e na sua saúde, a Multicare<br> disponibiliza um serviço de entrega de<br> medicamentos aos clientes que têm um seguro<br> de saúde com a cobertura Medicina Online e/ou<br> Médico Domicílio. O serviço de Entrega de<br> Medicamentos está disponível 24h por dia, 365<br> dias por ano. Sem custos de entrega.</p>
                </div>
                <div class="tw-pt-12 lg:tw-pt-0">
                    <img src="~@/assets/img/icons/reembolso.svg">
                    <h3 class="tw-pt-4">Pedido de Reembolso<br>De despesas de saúde online</h3>
                    <p class="tw-pt-2">Pedido de reembolso das despesas de saúde<br> com fotografia da fatura, através da área de<br> cliente MyFidelidade, no computador ou na app.</p>
                </div>
            </div>
        </section>

        <section class="ensure tw-py-10 lg:tw-py-16">
            <div class="tw-container">
                <div class="tw-relative tw-grid tw-grid-cols-1 tw-px-3 lg:tw-px-0 lg:tw-grid-cols-4 lg:tw-gap-8">
                    <div>
                        <p><strong>Marca líder</strong> em Seguros<br> de Saúde</p>
                    </div>
                    <div class="tw-pt-10 lg:tw-pt-0">
                        <p><strong>Até 20% desconto</strong> sobre<br> o prémio comercial para proteger toda a família</p>
                    </div>
                    <div class="tw-pt-10 lg:tw-pt-0">
                        <p><strong>Check-Up gratuito</strong> de 2<br> em 2 anos (nas condições em vigor<br> em cada momento)</p>
                    </div>
                    <div class="tw-pt-10 lg:tw-pt-0">
                        <p><strong>Acesso a médicos</strong> por telefone<br> e online</p>
                    </div>
                </div>
            </div>
        </section>

        <footer>
            <div class="tw-container tw-grid tw-grid-ccols-1 lg:tw-flex tw-text-left tw-py-8 lg:tw-py-16 lg:tw-gap-12">
                <div>
                    <img src="~@/assets/img/logo_multicare.svg">
                </div>
                <div class="tw-pt-5 lg:tw-pt-0">
                    <p>Não dispensa a consulta da informação pré-contratual<br class="lg:tw-hidden"> e contratual legalmente exigida. Este seguro de saúde<br class="lg:tw-hidden"> é da Fidelidade – Companhia de seguros, S.A…</p>
                </div>
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
import FormError from '@/components/FormError.vue';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';

export default {
    components: {
        Form,
        FormSuccess,
        FormError,
        KwPixel,
        ModalContainer,
        Terms,
    },
    methods: {
        scrollTo(target) {
            document.querySelector(`${target}`).scrollIntoView({
                behavior: 'smooth',
            });
        },
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
        const data = {
            url: window.location.hostname,
            pubid: this.pubid,
            utm_source: this.$route.query.utm_source,
            utm_campaign: this.$route.query.utm_campaign,
            utm_medium: this.$route.query.utm_medium,
            utm_content: this.$route.query.utm_content,
            utm_term: this.$route.query.utm_term,
            ua_device: this.$store.state.ua_device,
            ua_browser: this.$store.state.ua_browser,
            ua_os: this.$store.state.ua_os,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => console.log(error));
    },
};
</script>
<style>

</style>
